<template slot="Content">
    <router-view></router-view>
</template>

<script>
    import router from '@/router/index.js'
    export default {
        name: 'MasterSearch',
        router,
    };
</script>